<!--
 * @Author: Junjie
 * @Date: 2022-06-21 16:25:42
 * @LastEditTime: 2022-09-05 16:08:58
 * @email: 781433561@qq.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/monitor/running/modules/DevRunningDetail.vue
-->
<template>
  <a-spin :spinning="confirmLoading">
    <a-card :style="{marginTop: '20px;'}">
        <a-descriptions :title="model.devId_dictText">
          <a-descriptions-item label="当前状态">
            <span v-if="model.curStatus==1">
                <a-tag color="#52c41a">运行</a-tag>
            </span>
            <span v-else>
                <a-tag color="gray">停止</a-tag>
            </span>
          </a-descriptions-item>
          <a-descriptions-item label="上次开启时刻">{{model.lastOpenTime}}</a-descriptions-item>
          <a-descriptions-item label="持续运行时长(分)">{{model.continuousRunningDuration}}</a-descriptions-item>
          <a-descriptions-item label="停机次数">{{model.shutdownCount}}</a-descriptions-item>
          <a-descriptions-item label="首次开启时刻">{{model.firstOpenTime}}</a-descriptions-item>
          <a-descriptions-item label="历史累计运行时长(分)">{{model.totalRunningDuration}}</a-descriptions-item>
        </a-descriptions>
      </detail-list>

      <a-card>
        <v-chart :option="historyDataLineOpts" style="width: 100%; height: 198px; background-color: #fff" />
      </a-card>
    </a-card>
  </a-spin>
</template>

<script>

  import { getAction } from '@/api/manage'
    import moment from 'dayjs'
  import { LineChart } from 'echarts/charts'

  export default {
    name: 'DevRunningDetail',
    components: {
      LineChart,
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model: {
            devId_dictText: '',
            curStatus: 0,
            lastOpenTime: '',
            continuousRunningDuration: 0,
            shutdownCount: 0,
            firstOpenTime: '',
            totalRunningDuration: 0,
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
        },
        historyDataLineOpts: {},
        url: {
          loadDevRuningInfo: "/monitor/devRunning/list",
          loadHistoryData: '/monitor/data/pointdata',
        }
      }
    },
    computed: {
      formDisabled () {
        return this.disabled
      },
    },
    methods: {
      show (devId) {
        this.visible = true;
         this.$nextTick(() => {
          this.loadDevRuningData(devId);
        });
        
      },
      loadDevRuningData (devId) {
        getAction(this.url.loadDevRuningInfo, { devId: devId }).then(res => {
          if (res.success && res.result.records.length > 0) {
            this.model = Object.assign(this.model, res.result.records[0]);
            this.loadHistoryData()
          } else {
            this.$message.error('设备未统计运行情况，请检查是否配置了运行条件！');
          }
        })
      },
      loadHistoryData () {
        const startTime = moment().add(-30, 'days').format('YYYY-MM-DD HH:mm:ss');
        const endTime = moment().format('YYYY-MM-DD HH:mm:ss');
        const diffSeconds = moment(endTime).diff(moment(startTime), 'second');
        let interval = Math.floor(diffSeconds / 2000);
        interval = Math.max(1, interval);
        const parms = {
          startTime, endTime, points: this.model.pointCode, interval
        }
        getAction(this.url.loadHistoryData, parms).then(res => {
          this.historyDataLineOpts = res.data;
        })
      }
    }
  }
</script>